import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import {Slider} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    infoIcon: {
        color: theme.palette.common.white
    },
    tooltipColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: "grey"
    },
    roundScoreBlueTop: {
        borderRadius: 50,
        height: 25,
        width: 25,
        fontSize: 14,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "blue",
        marginTop: -52,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    roundScoreBlueBottom: {
        borderRadius: 50,
        height: 25,
        width: 25,
        fontSize: 14,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "blue",
        marginTop: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    roundScoreRedTop: {
        borderRadius: 50,
        height: 25,
        width: 25,
        fontSize: 14,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "red",
        marginTop: -52,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    roundScoreRedBottom: {
        borderRadius: 50,
        height: 25,
        width: 25,
        fontSize: 14,
        color: theme.palette.common.white,
        fontWeight: 'bold',
        backgroundColor: "red",
        marginTop: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
}));

const VideoProgressSlider = withStyles((theme) => ({
    root: {
        height: 2
    },
    thumb: {
        height: 15,
        width: 15,
        opacity: 0.5
    },
    active: {},
    valueLabel: {},
    track: {
        height: 5,
        color: theme.palette.common.white
    },
    rail: {
        height: 2,
        opacity: 0.5,
        color: theme.palette.common.white
    },
    mark: {
        height: 25,
        width: 1,
        color: theme.palette.common.white
    },
    markActive: {
        opacity: 1,
        backgroundColor: 'currentColor',
    },
}))(Slider);


export {useStyles, VideoProgressSlider};